import React, { Component } from "react";
import CustomLink from '../common/CustomLink';
import ErrorLoadingTileMessage from './ErrorLoadingTileMessage';
import { Typography } from "../ecosystem";
import { DashboardTile } from '../dashboard/DashboardTile';

class ErrorLoadingTile extends Component {
    constructor(params) {
        super(params);
    }

    render() {

        const {
            errorMsg,
            linkProps,
            tilename,
            tileclass,
            isMobile
        } = this.props;

        return (
            <>
                {this.props && this.props.error &&
                    <DashboardTile
                        className={"card-error-container " + (tileclass ? tileclass : '')}
                        title={tilename}
                        noBorder={true}
                    >
                        <div className="col-12">
                            <ErrorLoadingTileMessage
                                errorMsg={errorMsg}
                            />
                        </div>
                        {linkProps && <CustomLink linkProps={{ ...linkProps }}><span /></CustomLink>}
                    </DashboardTile>}
            </>
        );
    }
}

export default ErrorLoadingTile;